<template>
  <div
    class="index"
    @touchstart="touchstart"
    @touchmove="touchmove"
    @touchend="touchend"
  >
    <div class="header">
      <div class="headerBox">
        <p class="foundo">
          <img
            v-if="logoindex == 1"
            src="https://img.ohdat.io/foundo-website/assets/index/logo.png"
            alt=""
          />
          <img
            v-if="logoindex == 2"
            src="https://img.ohdat.io/foundo-website/assets/index/logo1.png"
            alt=""
          />
        </p>
        <div class="all_logo" v-if="alllogo">
          <p class="all_logo_app" @click="questionnaire">APPLY</p>
          <img
            @click="discord"
            src="https://img.ohdat.io/foundo-website/assets/index/discord.png"
            alt=""
          />
          <img
            @click="twitter"
            src="https://img.ohdat.io/foundo-website/assets/index/twitter.png"
            alt=""
          />
          <img
            @click="playMusic"
            class="play_musicm"
            src="https://img.ohdat.io/foundo-website/assets/index/play.png"
            alt=""
            srcset=""
            v-show="playMusict"
          />
          <img
            @click="playMusic"
            class="play_musicm"
            src="https://img.ohdat.io/foundo-website/assets/index/play_false.png"
            alt=""
            srcset=""
            v-show="!playMusict"
          />
          <!-- <img
              @click="instagram"
              src="https://img.ohdat.io/foundo-website/assets/index/instagram.png"
              alt=""
          /> -->
        </div>
        <div v-if="alllogo">
          <!-- <div class="jiapc">
            <div class="jiabtn">
              <p class="jiabtn1">
                <img
                  src="https://img.ohdat.io/foundo-website/assets/index/jia.png"
                  alt=""
                  srcset=""
                />
              </p>
              <p class="jiabtn2 jiabtn3">
                <img
                  src="https://img.ohdat.io/foundo-website/assets/index/jian.png"
                  alt=""
                  srcset=""
                />
              </p>
              <p class="jiabtn_text jiabtn_text1 jiabtn2" @click="moveProduct">
                LIMITED DROP
              </p>
              <p class="jiabtn_text jiabtn2" @click="moveFaq">FAQ</p>
              <p class="jiabtn_text jiabtn2" @click="moveTeam">TEAM</p>
              <p class="jiabtn_text jiabtn2" @click="moveManifesto">
                MANIFESTO
              </p>
            </div>
          </div> -->
          <div class="jia_m">
            <div class="jiabtn" v-if="!jiashow">
              <p>
                <img
                  @click="showJia"
                  src="https://img.ohdat.io/foundo-website/assets/index/jia.png"
                  alt=""
                  srcset=""
                />
              </p>
            </div>
            <div class="jiabtn" v-if="jiashow">
              <p>
                <img
                  @click="showJia"
                  src="https://img.ohdat.io/foundo-website/assets/index/jian.png"
                  alt=""
                  srcset=""
                />
              </p>
              <p class="jiabtn_text" @click="moveProduct">LIMITED DROP</p>
              <p class="jiabtn_text" @click="moveFaq">FAQ</p>
              <!-- <p class="jiabtn_text" @click="moveTeam">TEAM</p> -->
              <p class="jiabtn_text" @click="moveManifesto">MANIFESTO</p>
              <p class="jiabtn_text" @click="about">About</p>
              <p class="jiabtn_text jiabtn_text1" @click="questionnaire">
                APPLY
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :style="`height:${heightw}px`"
      class="foundo_t"
      v-show="showNumber == 1"
    >
      <div>
        <div class="foundo_tbox">
          <input
            @click="tttt"
            type="text"
            v-model="invitation"
            placeholder="ENTER PASSCODE"
            v-on:keyup.enter="pscdEnter"
          />
          <div class="you" @click="pscdEnter">
            <img
              class="you1 youpc"
              src="https://img.ohdat.io/foundo-website/assets/index/you.png"
              alt=""
              srcset=""
            />
            <img
              class="you1 youm"
              src="https://img.ohdat.io/foundo-website/assets/index/you_m.png"
              alt=""
              srcset=""
            />
            <img
              class="you2"
              src="https://img.ohdat.io/foundo-website/assets/index/youxian.png"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div class="wrong">{{ wrong }}</div>
      </div>
    </div>
    <div
      class="foundo_c"
      :style="`height:${heightw}px`"
      v-show="showNumber == 2"
    >
      <audio
        src="https://img.ohdat.io/foundo/logo-begin-1.mp3"
        preload="auto"
        ref="begin_audio1"
      ></audio>
      <video
        preload="auto"
        webkit-playsinline="true"
        playsinline="true"
        id="myVideo"
        muted
        v-show="hide"
        x-webkit-airplay="true"
        x5-playsinline="true"
        x5-video-orientation="portraint"
      >
        <source :src="imged" type="video/mp4" />
      </video>
    </div>
    <div class="foundo_b" v-show="showNumber == 3">
      <img
        @click="playMusic"
        class="play_music"
        src="https://img.ohdat.io/foundo-website/assets/index/play.png"
        alt=""
        srcset=""
        v-show="playMusict"
      />
      <img
        @click="playMusic"
        class="play_music"
        src="https://img.ohdat.io/foundo-website/assets/index/play_false.png"
        alt=""
        srcset=""
        v-show="!playMusict"
      />
      <audio
        src="https://img.ohdat.io/foundo/logo-loop-1.mp3"
        preload="auto"
        ref="loop_audio"
        autoplay
        loop
      ></audio>
      <video
        id="myVideo1"
        :class="imgcode == 1 ? 'before' : 'before1'"
        preload="auto"
        webkit-playsinline="true"
        playsinline="true"
        autoplay
        muted
        loop
        :src="img"
        x-webkit-airplay="true"
        x5-playsinline="true"
        x5-video-orientation="portraint"
      >
        <!-- <source :src="img" type="video/mp4" /> -->
      </video>
      <div class="bottobtn" @click="moveTo">{{ back }}</div>
      <full-page :options="options" ref="fullpage">
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_f" :class="anim ? 'anned' : 'anning'">
                scroll to explore
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_loop1">
                <!-- <div class="cardbar">
                  <img
                    src="https://img.ohdat.io/foundo-website/assets/index/card.png"
                    alt=""
                    class="pc"
                  />
                  <img
                    src="https://img.ohdat.io/foundo-website/assets/index/card_small_m.png"
                    alt=""
                    class="mm"
                  />
                </div> -->
                <div class="logo_loop_p" :class="anim1 ? 'anned' : 'ann'">
                  <video
                    width="100%"
                    class="video_mint"
                    autoplay
                    loop
                    muted
                    preload="auto"
                    webkit-playsinline="true"
                    playsinline="true"
                    x-webkit-airplay="true"
                    x5-playsinline="true"
                    x5-video-orientation="portraint"
                    id="videoimged"
                  >
                    <source
                      src="https://img.ohdat.io/foundo-website/assets/mp4/card_mint.mp4"
                      type="video/mp4"
                    />
                  </video>
                  <!-- <div class="passx_btned" @click="mintNow(1)">MINT NOW</div> -->
                  <!-- <div class="passx">
                    <div class="passx_title">FOUNDER PASS X 150</div>
                    <div class="passx_text">
                      <p>
                        FOUNDO Founder Pass is 150 VIP membership passcards for
                        art collectors, up-and-coming artists and luxury fashion
                        enthusiasts granting exclusive access to private Discord
                        community, bespoke luxury product service and limited
                        edition capsule collaborations.
                      </p>
                      <div class="passx_btn">MINT SOON</div>
                      <div class="passx_btned" @click="mintNow(1)">
                        MINT NOW
                      </div>
                    </div>
                  </div> -->
                </div>
                <!-- <div class="youbtn"></div> -->
                <div class="logaall_m">
                  <img
                    @click="discord"
                    src="https://img.ohdat.io/foundo-website/assets/index/discord.png"
                    alt=""
                  />
                  <img
                    @click="twitter"
                    src="https://img.ohdat.io/foundo-website/assets/index/twitter.png"
                    alt=""
                  />
                  <!-- <img @click="instagram" src="https://img.ohdat.io/foundo-website/assets/index/instagram.png" alt="" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="artists" :class="anim0 ? 'anned' : 'ann'">
                <div class="artists_left">
                  <p class="artists_title"></p>
                  <div class="artists_sort artists_marg">
                    <p class="artists_sortname">Glitch</p>
                    <div class="artists_sortdel">
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 1
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(1)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/Bongdoe.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">Bongdoe</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 2
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(2)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/C4RDNIAL.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">C4RDNIAL</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 3
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(3)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/KingXerox.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">King Xerox</p>
                      </div>
                    </div>
                  </div>
                  <div class="artists_sort">
                    <p class="artists_sortname">
                      Pop-Precisionism <br />
                      & Minimalism
                    </p>
                    <div class="artists_sortdel">
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 7
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(7)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/0xflat.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">0xflat</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 8
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(8)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/Terrell.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">Terrell</p>
                      </div>
                      <div class="artists_sortli">
                        <div class="redected">REDACTED</div>
                      </div>
                    </div>
                  </div>
                  <div class="artists_sort">
                    <p class="artists_sortname">AI</p>
                    <div class="artists_sortdel">
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 4
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(4)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/CharlesAI.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">CharlesAI</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 5
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(5)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/GeneKogan.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">Gene Kogan</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 6
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(6)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/Str4ngThing.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">Str4ngeThing</p>
                      </div>
                    </div>
                  </div>
                  <div class="artists_sort">
                    <p class="artists_sortname">On-chain</p>
                    <div class="artists_sortdel">
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 9
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(9)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/Diid.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">Diid</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 10
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(10)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/Smokestacks.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">Smokestacks</p>
                      </div>
                      <div class="artists_sortli">
                        <div class="redected">REDACTED</div>
                      </div>
                    </div>
                  </div>
                  <div class="artists_sort">
                    <p class="artists_sortname">Photography</p>
                    <div class="artists_sortdel">
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 11
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(11)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/KeithharingPhotoSet.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p1">Keith Haring Photo Set</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 12
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(12)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/LoinsDazy.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">Louis Dazy</p>
                      </div>
                      <div class="artists_sortli">
                        <div class="redected">REDACTED</div>
                      </div>
                    </div>
                  </div>
                  <div class="artists_sort">
                    <p class="artists_sortname">Surrealism</p>
                    <div class="artists_sortdel">
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 13
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(13)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/1dontknows.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">1dontknows</p>
                      </div>
                      <div class="artists_sortli">
                        <p
                          :class="
                            mySwiper_index == 14
                              ? 'artists_sortli_img_border'
                              : ''
                          "
                          class="artists_sortli_img"
                          @click="rightShow(14)"
                        >
                          <img
                            src="https://img.ohdat.io/foundo-website/assets/avatar_left/RedruM.png"
                            alt=""
                          />
                        </p>
                        <p class="artists_sortli_p">RedruM</p>
                      </div>
                      <div class="artists_sortli">
                        <div class="redected">REDACTED</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="artists_right">
                  <div class="artists_lunbo">
                    <div class="swiper-container" id="artists_del">
                      <div class="swiper-wrapper" ref="swiperfea">
                        <div
                          class="swiper-slide"
                          v-for="item in rightNow"
                          :key="item.img"
                        >
                          <div class="artists_box">
                            <p>
                              <img :src="item.img" alt="" />
                            </p>
                            <!-- <div class="artists_box_text">{{ item.text }}</div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-button-prev">
                      <img
                        src="https://img.ohdat.io/foundo-website/assets/avatar_right/left.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                    <div class="swiper-button-next">
                      <img
                        src="https://img.ohdat.io/foundo-website/assets/avatar_right/right.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                  </div>
                </div>
                <div class="artists_boxm">
                  <p class="artists_boxm_title">ARTISTS</p>
                  <div class="artists_boxm_lunbo">
                    <div class="swiper-container" id="artistsBoxm">
                      <div class="swiper-wrapper" ref="swiperfea">
                        <div class="swiper-slide">
                          <div class="artists_box">
                            <p class="artists_box_title">Glitch</p>
                            <div class="artists_box_li">
                              <p
                                class="artists_box_li_m"
                                @click="rightShowm(100)"
                              >
                                <img
                                  src="https://img.ohdat.io/foundo-website/assets/avatar_left/Bongdoe.png"
                                  alt=""
                                />
                              </p>
                              <p class="artists_box_li_p">Bongdoe</p>
                            </div>
                            <div class="artists_box_li1">
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(101)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/C4RDNIAL.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">C4RDNIAL</p>
                              </div>
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(102)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/KingXerox.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">King Xerox</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="swiper-slide">
                          <div class="artists_box">
                            <p class="artists_box_title">
                              Pop-Precisionism <br />
                              & Minimalism
                            </p>
                            <div class="artists_box_li">
                              <p
                                class="artists_box_li_m"
                                @click="rightShowm(106)"
                              >
                                <img
                                  src="https://img.ohdat.io/foundo-website/assets/avatar_left/0xflat.png"
                                  alt=""
                                />
                              </p>
                              <p class="artists_box_li_p">0xflat</p>
                            </div>
                            <div class="artists_box_li1">
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(107)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/Terrell.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">Terrell</p>
                              </div>
                              <div class="artists_box_li1_one">
                                <p class="artists_sortli_redected">REDACTED</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="swiper-slide">
                          <div class="artists_box">
                            <p class="artists_box_title">AI</p>
                            <div class="artists_box_li">
                              <p
                                class="artists_box_li_m"
                                @click="rightShowm(103)"
                              >
                                <img
                                  src="https://img.ohdat.io/foundo-website/assets/avatar_left/CharlesAI.png"
                                  alt=""
                                />
                              </p>
                              <p class="artists_box_li_p">CharlesAI</p>
                            </div>
                            <div class="artists_box_li1">
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(104)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/GeneKogan.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">Gene Kogan</p>
                              </div>
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(105)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/Str4ngThing.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">Str4ngeThing</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="swiper-slide">
                          <div class="artists_box">
                            <p class="artists_box_title">On-chain</p>
                            <div class="artists_box_li">
                              <p
                                class="artists_box_li_m"
                                @click="rightShowm(108)"
                              >
                                <img
                                  src="https://img.ohdat.io/foundo-website/assets/avatar_left/Diid.png"
                                  alt=""
                                />
                              </p>
                              <p class="artists_box_li_p">Diid</p>
                            </div>
                            <div class="artists_box_li1">
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(109)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/Smokestacks.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">Smokestacks</p>
                              </div>
                              <div class="artists_box_li1_one">
                                <p class="artists_sortli_redected">REDACTED</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="swiper-slide">
                          <div class="artists_box">
                            <p class="artists_box_title">Photography</p>
                            <div class="artists_box_li">
                              <p
                                class="artists_box_li_m"
                                @click="rightShowm(110)"
                              >
                                <img
                                  src="https://img.ohdat.io/foundo-website/assets/avatar_left/KeithharingPhotoSet.png"
                                  alt=""
                                />
                              </p>
                              <p class="artists_box_li_p">
                                Keith Haring<br />
                                Photo Set
                              </p>
                            </div>
                            <div class="artists_box_li1">
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(111)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/LoinsDazy.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">Louis Dazy</p>
                              </div>
                              <div class="artists_box_li1_one">
                                <p class="artists_sortli_redected">REDACTED</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="swiper-slide">
                          <div class="artists_box">
                            <p class="artists_box_title">Surrealism</p>
                            <div class="artists_box_li">
                              <p
                                class="artists_box_li_m"
                                @click="rightShowm(112)"
                              >
                                <img
                                  src="https://img.ohdat.io/foundo-website/assets/avatar_left/1dontknows.png"
                                  alt=""
                                />
                              </p>
                              <p class="artists_box_li_p">1dontknows</p>
                            </div>
                            <div class="artists_box_li1">
                              <div class="artists_box_li1_one">
                                <p
                                  class="artists_box_li_m"
                                  @click="rightShowm(113)"
                                >
                                  <img
                                    src="https://img.ohdat.io/foundo-website/assets/avatar_left/RedruM.png"
                                    alt=""
                                  />
                                </p>
                                <p class="artists_box_li_p">RedruM</p>
                              </div>
                              <div class="artists_box_li1_one">
                                <p class="artists_sortli_redected">REDACTED</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-button-prev">
                      <img
                        src="https://img.ohdat.io/foundo-website/assets/avatar_right/left.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                    <div class="swiper-button-next">
                      <img
                        src="https://img.ohdat.io/foundo-website/assets/avatar_right/right.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                  </div>
                </div>
                <div class="leftbtn">ARTISTS</div>
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_loop">
                <div class="characterbig">
                  <div>
                    <div class="character">
                      <div class="characterbox">
                        <div
                          class="characterbox_pc"
                          style="width: 100%; margin-left: 0"
                        >
                          <div class="imglogo" @click="handleMouseEnter1">
                            <video
                              width="100%"
                              style="object-fit: cover"
                              class="beforeimg"
                              :autoplay="play1"
                              muted
                              ref="video1"
                              preload="auto"
                              webkit-playsinline="true"
                              playsinline="true"
                              x-webkit-airplay="true"
                              x5-playsinline="true"
                              x5-video-orientation="portraint"
                              poster="https://img.ohdat.io/foundo-website/assets/index/team-su.png"
                            >
                              <source
                                src="https://img.ohdat.io/foundo-website/assets/mp4/team-su.mp4"
                                type="video/mp4"
                              />
                            </video>
                          </div>
                          <div class="logo_text">
                            <p class="title title_one">NAHIYA</p>
                            <p class="text">Creative Director & Founder</p>
                            <p class="text1">Ex-founder of KVK</p>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div class="characterbox_pc" style="width: 100%">
                          <div class="imglogo" @click="handleMouseEnter2">
                            <video
                              width="100%"
                              style="object-fit: cover"
                              class="beforeimg"
                              :autoplay="play2"
                              :loop="play2"
                              muted
                              ref="video2"
                              preload="auto"
                              webkit-playsinline="true"
                              playsinline="true"
                              x-webkit-airplay="true"
                              x5-playsinline="true"
                              x5-video-orientation="portraint"
                              poster="https://img.ohdat.io/foundo-website/assets/index/team-alberto.png"
                            >
                              <source
                                src="https://img.ohdat.io/foundo-website/assets/mp4/team-alberto.mp4"
                                type="video/mp4"
                              />
                            </video>
                          </div>
                          <div class="logo_text">
                            <p class="title title_one">EDISON</p>
                            <p class="text">Operations & Co-founder</p>
                            <p class="text2">Centeral Saint Martins</p>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div class="characterbox_pc" style="width: 100%">
                          <div class="imglogo" @click="handleMouseEnter3">
                            <video
                              width="100%"
                              style="object-fit: cover"
                              class="beforeimg"
                              :autoplay="play3"
                              :loop="play3"
                              muted
                              ref="video3"
                              preload="auto"
                              webkit-playsinline="true"
                              playsinline="true"
                              x-webkit-airplay="true"
                              x5-playsinline="true"
                              x5-video-orientation="portraint"
                              poster="https://img.ohdat.io/foundo-website/assets/index/team-jamie.png"
                            >
                              <source
                                src="https://img.ohdat.io/foundo-website/assets/mp4/team-jamie.mp4"
                                type="video/mp4"
                              />
                            </video>
                          </div>
                          <div class="logo_text">
                            <p class="title title_one">JAMIE</p>
                            <p class="text">Web3 Strategy/Marketing</p>
                            <p class="text"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="character">
                      <div class="characterbox">
                        <div
                          class="characterbox_pc"
                          style="width: 100%; margin-left: 0"
                        >
                          <div class="logo_text">
                            <div class="logo_icon">
                              <img
                                src="https://img.ohdat.io/foundo-website/assets/index/eml.png"
                                alt=""
                                srcset=""
                                @click="nahiyaMedia"
                              />
                              <img
                                src="https://img.ohdat.io/foundo-website/assets/index/twitter_team.png"
                                alt=""
                                srcset=""
                                @click="nahiyaTwitter"
                              />
                              <img
                                src="https://img.ohdat.io/foundo-website/assets/index/in.png"
                                alt=""
                                srcset=""
                                @click="nahiyaLinkedin"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div
                          class="characterbox_pc"
                          style="width: 100%; margin-left: 0"
                        >
                          <div class="logo_text">
                            <div class="logo_icon">
                              <img
                                src="https://img.ohdat.io/foundo-website/assets/index/twitter_team.png"
                                alt=""
                                srcset=""
                                @click="edisonTwitter"
                              />
                              <img
                                src="https://img.ohdat.io/foundo-website/assets/index/in.png"
                                alt=""
                                srcset=""
                                @click="edisonLinkedin"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div
                          class="characterbox_pc"
                          style="width: 100%; margin-left: 0"
                        >
                          <div class="logo_text">
                            <div class="logo_icon">
                              <img
                                src="https://img.ohdat.io/foundo-website/assets/index/twitter_team.png"
                                alt=""
                                srcset=""
                                @click="jamieTwitter"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="character character_mar">
                      <div class="characterbox">
                        <div
                          class="characterbox_pc"
                          style="width: 100%; margin-left: 0"
                        >
                          <div class="logo_text">
                            <p class="albetro">ALBERTO</p>
                            <p class="operation">Operation/Supply Chain</p>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div class="characterbox_pc" style="width: 100%">
                          <div class="logo_text">
                            <p class="albetro">LF</p>
                            <p class="operation">CTO<br />UCLA/UC Berkerly</p>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div class="characterbox_pc" style="width: 100%">
                          <div class="logo_text">
                            <p class="albetro">HAN</p>
                            <p class="operation">
                              Web3 Marketing<br />Ex-Patek Philippe
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="character character_mar">
                      <div class="characterbox">
                        <div
                          class="characterbox_pc"
                          style="width: 100%; margin-left: 0"
                        >
                          <div class="logo_text">
                            <p class="albetro1">0xYX</p>
                            <p class="operation">Product Design<br />Ex-KVK</p>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div class="characterbox_pc" style="width: 100%">
                          <div class="logo_text">
                            <p class="albetro">KΞRRY</p>
                            <p class="operation">Branding<br />Ex-Dazed</p>
                          </div>
                        </div>
                      </div>
                      <div class="characterbox">
                        <div class="characterbox_pc" style="width: 100%">
                          <div class="logo_text">
                            <p class="albetro">KLAD</p>
                            <p class="operation">
                              Content Lead<br />Worked with Burberry/Moncler
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="characterbig_m">
                  <div class="characterbig_m_left">
                    <div class="imglogo" @click="handleMouseEnterm1">
                      <video
                        width="100%"
                        class="beforeimg"
                        style="object-fit: cover"
                        :autoplay="playm1"
                        muted
                        ref="videom1"
                        preload="auto"
                        webkit-playsinline="true"
                        playsinline="true"
                        x-webkit-airplay="true"
                        x5-playsinline="true"
                        x5-video-orientation="portraint"
                        poster="https://img.ohdat.io/foundo-website/assets/index/team-su.png"
                      >
                        <source
                          src="https://img.ohdat.io/foundo-website/assets/mp4/team-su.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    <div class="logo_text">
                      <p class="title">NAHIYA</p>
                      <p class="text">Creative Director & Founder</p>
                      <p class="text1">Ex-founder of KVK</p>
                      <div class="logo_icon">
                        <img
                          src="https://img.ohdat.io/foundo-website/assets/index/eml.png"
                          alt=""
                          srcset=""
                          @click="nahiyaMedia"
                        />
                        <img
                          src="https://img.ohdat.io/foundo-website/assets/index/twitter_team.png"
                          alt=""
                          srcset=""
                          @click="nahiyaTwitter"
                        />
                        <img
                          src="https://img.ohdat.io/foundo-website/assets/index/in.png"
                          alt=""
                          srcset=""
                          @click="nahiyaLinkedin"
                        />
                      </div>
                    </div>
                    <div class="imglogo" @click="handleMouseEnterm2">
                      <video
                        width="100%"
                        style="object-fit: cover"
                        class="beforeimg"
                        :autoplay="playm2"
                        :loop="playm2"
                        muted
                        ref="videom2"
                        preload="auto"
                        webkit-playsinline="true"
                        playsinline="true"
                        x-webkit-airplay="true"
                        x5-playsinline="true"
                        x5-video-orientation="portraint"
                        poster="https://img.ohdat.io/foundo-website/assets/index/team-alberto.png"
                      >
                        <source
                          src="https://img.ohdat.io/foundo-website/assets/mp4/team-alberto.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    <div class="logo_text">
                      <p class="title title_one">EDISON</p>
                      <p class="text">Operations & Co-founder</p>
                      <p class="text1">Centeral Saint Martins</p>
                      <div class="logo_icon">
                        <img
                          src="https://img.ohdat.io/foundo-website/assets/index/twitter_team.png"
                          alt=""
                          srcset=""
                          @click="edisonTwitter"
                        />
                        <img
                          src="https://img.ohdat.io/foundo-website/assets/index/in.png"
                          alt=""
                          srcset=""
                          @click="edisonLinkedin"
                        />
                      </div>
                    </div>
                    <div class="imglogo" @click="handleMouseEnterm3">
                      <video
                        width="100%"
                        style="object-fit: cover"
                        class="beforeimg"
                        :autoplay="playm3"
                        :loop="playm3"
                        muted
                        ref="videom3"
                        preload="auto"
                        webkit-playsinline="true"
                        playsinline="true"
                        x-webkit-airplay="true"
                        x5-playsinline="true"
                        x5-video-orientation="portraint"
                        poster="https://img.ohdat.io/foundo-website/assets/index/team-jamie.png"
                      >
                        <source
                          src="https://img.ohdat.io/foundo-website/assets/mp4/team-jamie.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    <div class="logo_text">
                      <p class="title title_one">JAMIE</p>
                      <p class="text">Web3 Strategy/Marketing</p>
                      <p class="text"></p>
                      <div class="logo_icon">
                        <img
                          src="https://img.ohdat.io/foundo-website/assets/index/twitter_team.png"
                          alt=""
                          srcset=""
                          @click="jamieTwitter"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="characterbig_m_right">
                    <p class="albetro">ALBERTO</p>
                    <p class="operation">Operation/Supply Chain</p>
                    <p class="albetro">LF</p>
                    <p class="operation">CTO<br />UCLA/UC Berkerly</p>
                    <p class="albetro">HAN</p>
                    <p class="operation">
                      Web3 Marketing<br />Ex-Patek Philippe
                    </p>
                    <p class="albetro">KΞRRY</p>
                    <p class="operation">Branding<br />Ex-Dazed</p>
                    <p class="albetro">0xYX</p>
                    <p class="operation">Product Design<br />Ex-KVK</p>
                    <p class="albetro">KLAD</p>
                    <p class="operation">
                      Content Lead<br />Worked with Burberry/Moncler
                    </p>
                  </div>
                </div>
                <div class="leftbtn">TEAM</div>
                <!-- <div class="bottobtn" @click="moveTo">BACK</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_loop">
                <div class="logo_loop_p" :class="anim0 ? 'anned' : 'ann'">
                  <p class="text_transform twoer">
                    <span style="font-family: foundoBold; letter-spacing: 0px"
                      >FOUNDO®</span
                    >
                    is a new luxury brand that uses the latest in blockchain
                    technology, superior materials and world-class craftsmanship
                    to provide customer-centric products and experiences. It has
                    an extensive line of collections ranging from fine jewelry,
                    home goods, bags, accessorized installations, artwork to
                    NFTs - seeking to unite the virtual-reality world with
                    inter-human verse.
                  </p>
                  <p class="text_transform twoer_m">
                    <span style="font-family: foundoBold">FOUNDO®</span> is a
                    new luxury brand that uses the latest in blockchain
                    technology, superior materials and world-class craftsmanship
                    to provide customer-centric products and experiences. It has
                    an extensive line of collections ranging from fine jewelry,
                    home goods, bags, accessorized installations, artwork to
                    NFTs - seeking to unite the virtual-reality world with
                    inter-human verse.
                  </p>
                </div>
                <div class="leftbtn">ABOUT</div>
                <!-- <div class="bespoke">
                  <p class="route">MY COLLECTIONS</p>
                  <div class="swipercus">
                    <div class="swiper-container" id="swiperCus">
                      <div class="swiper-wrapper" ref="swiperfea">
                        <div class="swiper-slide">
                          <img src="https://img.ohdat.io/foundo-website/assets/despoke/2.png" alt="" />
                        </div>
                        <div class="swiper-slide">
                          <img src="https://img.ohdat.io/foundo-website/assets/despoke/0.png" alt="" />
                        </div>
                        <div class="swiper-slide">
                          <img src="https://img.ohdat.io/foundo-website/assets/despoke/1.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div class="swiper-button-prev">
                      <img src="https://img.ohdat.io/foundo-website/assets/despoke/left.png" alt="" srcset="" />
                    </div>
                    <div class="swiper-button-next">
                      <img src="https://img.ohdat.io/foundo-website/assets/despoke/right.png" alt="" srcset="" />
                    </div>
                  </div>
                  <p class="title">Bespoke with your NFT and FOINFO Pass</p>
                  <div class="bespoke_btn" @click="mintNow(2)">Bespoke NOW</div>
                  <p class="text">Free shipping on orders</p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_loop">
                <div class="logo_loop_p" :class="anim2 ? 'anned' : 'ann'">
                  <p class="title">WHAT IS THE FOUNDO FOUNDER PASS?</p>
                  <p class="text">
                    The FOUNDO Founder Pass is sold on an invite-only basis and
                    functions as the access pass to our carefully curated
                    private club for art collectors, up-and-coming artists and
                    luxury fashion enthusiasts.
                  </p>
                  <p class="title"></p>
                  <p class="text">
                    It grants exclusive access to our Season 1 artist collab
                    drops, bespoke luxury product service, future collectibles,
                    Discord community, capsule collaborations and IRL exclusive
                    events.
                  </p>
                  <p class="title">WHEN IS MINT?</p>
                  <p class="text">
                    Mint is currently closed, please follow our Twitter or
                    Discord to get an invite when we open up again.
                  </p>
                </div>
                <div class="leftbtn">FAQ</div>
                <!-- <div class="bottobtn" @click="moveTo">BACK</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_loop">
                <div class="logo_loop_p" :class="anim5 ? 'anned' : 'ann'">
                  <p class="text_top text_transform">
                    Web3 is recognized as a transformative force by powers
                    across the world. <br />We witness the unwavering conviction
                    of the contributors and believers. <br />It is time for us
                    to introduce FOUNDO, our goals and ambitions.
                  </p>
                  <p class="text_top text_transform">
                    For and by the new generation, <br />We will create an
                    always-on new luxury and collector-grade experience.<br />
                    We will practice the philosophy of longtermism. <br />We
                    will achieve fruitful co-prosperity with our followers.
                  </p>
                  <p class="text_top text_transform">
                    FOUNDO will spark a prairie fire. <br />The world will join
                    our revolution. <br />This new world will be defined by
                    change, progress, and innovation. <br />The future will only
                    arrive when more change makers become the new generation.
                  </p>
                  <p class="text_top text_transform">
                    Together, we will be builders, creators and disruptors.
                    <br />Together, we will be Prometheus of our time.<br />
                    Together, we will build FOUNDO world.
                  </p>
                  <p class="text_top text_transform">
                    Together, we will rise as one.
                  </p>
                </div>
                <div class="leftbtn">MANIFESTO</div>
                <!-- <div class="bottobtn" @click="moveTo">BACK</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_loop1 titletop">
                <video
                  width="100%"
                  class="videoimg"
                  autoplay
                  loop
                  muted
                  preload="auto"
                  webkit-playsinline="true"
                  playsinline="true"
                  x-webkit-airplay="true"
                  x5-playsinline="true"
                  x5-video-orientation="portraint"
                  id="videoimg1"
                >
                  <source
                    src="https://img.ohdat.io/foundo-website/assets/mp4/NECKLACE.mp4?tr=orig"
                    type="video/mp4"
                  />
                </video>
                <div class="logo_loop_p" :class="anim6 ? 'anned' : 'ann'">
                  CROSS NECKLACE <br />
                  LIMITED EDITION OF 200 <br />
                  18-KARAT GOLD
                </div>
                <div class="leftbtn">LIMITED DROP</div>
                <div class="rightbtn">
                  <img
                    @click="next"
                    src="https://img.ohdat.io/foundo-website/assets/index/right.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="rightbtn_m">
                  <img
                    @click="next"
                    src="https://img.ohdat.io/foundo-website/assets/index/xia.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <!-- <div class="bottobtn" @click="moveTo">BACK</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="box3">
            <div :style="`height:${heightw}px`">
              <div class="logo_loop1 titletop">
                <video
                  width="100%"
                  class="videoimg"
                  autoplay
                  loop
                  muted
                  preload="auto"
                  webkit-playsinline="true"
                  playsinline="true"
                  x-webkit-airplay="true"
                  x5-playsinline="true"
                  x5-video-orientation="portraint"
                  id="videoimg2"
                >
                  <source
                    src="https://img.ohdat.io/foundo-website/assets/mp4/scarf.mp4?tr=orig"
                    type="video/mp4"
                  />
                </video>
                <p class="logo_loop_p" :class="anim7 ? 'anned' : 'ann'">
                  CITIZEN SCARF<br />
                  SPECIAL EDITION FROM<br />
                  OUR DEBUT COLLECTION CITIZEN 01<br />
                  100% SILK / CASHMERE / WOOL
                </p>
                <div class="leftbtn">
                  <img
                    @click="up"
                    src="https://img.ohdat.io/foundo-website/assets/index/left.png"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </full-page>
      <!-- mint弹框 -->
      <div class="mint" v-if="mint_now">
        <video
          muted
          preload="auto"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="true"
          x5-playsinline="true"
          x5-video-orientation="portraint"
          style="display: none"
        >
          <source
            src="https://img.ohdat.io/foundo-website/assets/mp4/mintPage.mp4"
            type="video/mp4"
          />
        </video>
        <video
          muted
          preload="auto"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="true"
          x5-playsinline="true"
          x5-video-orientation="portraint"
          style="display: none"
        >
          <source
            src="https://img.ohdat.io/foundo-website/assets/mp4/processing.mp4"
            type="video/mp4"
          />
        </video>
        <div class="mint_box" v-if="mint_now_number == 1">
          <!-- <div class="mint_header">1/3</div> -->
          <div class="close" @click="close">
            <img
              src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
              alt=""
            />
          </div>
          <p class="title">CONNECT WALLET</p>
          <div class="wallet" @click="metaMaskConnect">METAMASK</div>
          <div class="wallet" @click="walletConnectConnect">WALLETCONNECT</div>
          <p class="illustrate">
            WALLETS ARE USED TO SEND, RECEIVED AND STORE DIGITAL ASSETS.<br />
            START BY SELECTING A WALLET TO CONNECT TO VAULT, THEN BEGIN MINTING.
          </p>
          <p class="illustrate_m">
            WALLETS ARE USED TO SEND, RECEIVED AND STORE DIGITAL ASSETS. START
            BY SELECTING A WALLET TO CONNECT TO VAULT, THEN BEGIN MINTING.
          </p>
        </div>
        <div class="mint_box mint_box_m" v-if="mint_now_number == 2">
          <!-- <div class="mint_header">2/3</div> -->
          <div class="close" @click="close">
            <img
              src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
              alt=""
            />
          </div>
          <div class="adress_log">
            <p class="adress">{{ walletAddress }}</p>
            <div class="logout_xian"></div>
            <div class="logout_btn" @click="logout">Log Out</div>
          </div>
          <p class="title1">GET YOUR FOUNDER PASS</p>
          <div class="confirm_box">
            <div class="confirm_box_left">
              <p class="card">
                <img
                  src="https://img.ohdat.io/foundo-website/assets/index/card_small.png"
                  alt=""
                />
              </p>
              <p class="card_text">
                THE EXCLUSIVE PASSCARD TO EXPLORING FOUNDO WORLD
              </p>
            </div>
            <div class="confirm_box_right">
              <div class="confirm_box_righthang margintoped">
                <p class="total">TOTAL FOUNDER PASS PRICE:</p>
                <p class="number">
                  <span>{{ ethPrice }}</span>
                  <img
                    src="https://img.ohdat.io/foundo-website/assets/index/eth.png"
                    alt=""
                    srcset=""
                  />
                </p>
              </div>
              <p class="total margintop">
                {{ original_stock - $store.state.order.orderInfo.stock }} of
                {{ original_stock }} MINTED*
              </p>
              <div class="minted">
                <div
                  class="mintednei"
                  :style="`width:${
                    ((original_stock - $store.state.order.orderInfo.stock) /
                      original_stock) *
                    100
                  }%`"
                ></div>
              </div>
              <div class="confirm_box_righthang">
                <p class="total">TOTAL PASS REDEEMABLE:</p>
                <div class="total1">
                  <!-- <p v-if="limitall == 2">
                    <img
                      class="imgmar1"
                      @click="jianTrue"
                      v-if="limit == 2"
                      src="https://img.ohdat.io/foundo-website/assets/index/jiantrue.png"
                      alt=""
                    />
                    <img
                      class="imgmar1"
                      style="cursor: not-allowed"
                      v-if="limit == 1"
                      src="https://img.ohdat.io/foundo-website/assets/index/jianfalse.png"
                      alt=""
                    />
                  </p>
                  <p>{{ limit }}</p>
                  <p v-if="limitall == 2">
                    <img
                      class="imgmar"
                      @click="jiaTrue"
                      v-if="limit == 1"
                      src="https://img.ohdat.io/foundo-website/assets/index/jiatrue.png"
                      alt=""
                    />
                    <img
                      class="imgmar"
                      style="cursor: not-allowed"
                      v-if="limit == 2"
                      src="https://img.ohdat.io/foundo-website/assets/index/jiafalse.png"
                      alt=""
                    />
                  </p> -->
                  <div
                    v-if="limit > 1"
                    class="sel"
                    @click="seldownShow"
                    :style="!seltion ? '' : 'border-bottom:none'"
                  >
                    {{ selectNum }}
                    <img
                      src="https://img.ohdat.io/foundo-website/assets/index/down.png"
                      v-if="!seltion"
                    />
                    <img
                      src="https://img.ohdat.io/foundo-website/assets/index/up.png"
                      v-else
                    />
                  </div>
                  <div v-else class="selno">
                    <span>{{ limit }}</span>
                  </div>
                  <div class="selDown" v-show="seltion">
                    <div @click="selNum(itemSel)">
                      <span>{{ itemSel }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="confirm_box_righthang margintop">
                <p class="total">TOTAL PRICE:</p>
                <p class="number">
                  <span>{{ totalPrice }}</span>
                  <img
                    src="https://img.ohdat.io/foundo-website/assets/index/eth.png"
                    alt=""
                    srcset=""
                  />
                </p>
              </div>
              <div class="confirm_btnbox">
                <p v-if="status == -1" class="confirm_btning">CONFIRM</p>
                <p v-else-if="status == 0" class="confirm_btning">CONFIRM</p>
                <p
                  v-else-if="status == 1 && limit != 0 && mint_btn"
                  class="confirm_btn"
                  @click="mint"
                >
                  CONFIRM
                </p>
                <p
                  v-else-if="status == 1 && limit != 0 && !mint_btn"
                  class="confirm_btning"
                >
                  CONFIRM
                </p>
                <p v-else-if="status == 1 && limit == 0" class="confirm_btning">
                  CONFIRM
                </p>
                <p
                  v-else-if="status == 4 && limit != 0 && mint_btn"
                  class="confirm_btn"
                  @click="mint"
                >
                  CONFIRM
                </p>
                <p
                  v-else-if="status == 4 && limit != 0 && !mint_btn"
                  class="confirm_btning"
                >
                  CONFIRM
                </p>
                <p v-else-if="status == 4 && limit == 0" class="confirm_btning">
                  CONFIRM
                </p>
                <div class="hint text_transform">
                  <p v-if="status == -1">Sold out!</p>
                  <p v-else-if="status == 0">Not started yet.</p>
                  <p v-else-if="available == 0">You are not whitelisted.</p>
                  <p v-else-if="limit == 0">You have already minted.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mint_box1" v-if="mint_now_number == 3">
          <!-- <div class="mint_header">3/3</div> -->
          <div class="close" @click="close">
            <img
              src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
              alt=""
            />
          </div>
          <div class="xian"></div>
          <div class="progress_bar">
            <div class="progress_box" :style="`width:${percentage}%`"></div>
            <p class="loading">
              MINTING
              <span>...</span>
            </p>
          </div>
          <div class="mpvi">
            <video
              width="100%"
              autoplay
              loop
              muted
              preload="auto"
              webkit-playsinline="true"
              playsinline="true"
              x-webkit-airplay="true"
              x5-playsinline="true"
              x5-video-orientation="portraint"
            >
              <source
                src="https://img.ohdat.io/foundo-website/assets/mp4/processing.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <div class="mint_box2" v-if="mint_now_number == 4">
          <div class="close" v-if="ennde" @click="close">
            <img
              src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
              alt=""
            />
          </div>
          <video
            id="myVideoend"
            loop
            autoplay
            preload="auto"
            webkit-playsinline="true"
            playsinline="true"
            x-webkit-airplay="true"
            x5-playsinline="true"
            x5-video-orientation="portraint"
          >
            <source
              src="https://img.ohdat.io/foundo-website/assets/mp4/mintPage.mp4"
              type="video/mp4"
            />
          </video>
          <div class="wenan" v-if="ennde">
            <p class="text">
              MINTING SUCCESS!<br />
              NOW, LET’S ENTER INTO FOUNDO WORLD.
            </p>
            <div class="opensea" @click="opensea">
              <p>VIEW ON OPENSEA</p>
              <p>
                <img
                  src="https://img.ohdat.io/foundo-website/assets/index/opensea.png"
                  alt=""
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- bespoke_mint弹框 -->
      <div class="mint" v-if="bespoke_now">
        <div class="mint_box" v-if="bespoke_now_number == 1">
          <div class="close" @click="closeend">
            <img
              src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
              alt=""
            />
          </div>
          <p class="title">CONNECT WALLET</p>
          <div class="wallet" @click="metaMaskConnect">METAMASK</div>
          <div class="wallet" @click="walletConnectConnect">WALLETCONNECT</div>
          <p class="illustrate">
            WALLETS ARE USED TO SEND, RECEIVED AND STORE DIGITAL ASSETS.<br />
            START BY SELECTING A WALLET TO CONNECT TO VAULT, THEN BEGIN MINTING.
          </p>
          <p class="illustrate_m">
            WALLETS ARE USED TO SEND, RECEIVED AND STORE DIGITAL ASSETS. START
            BY SELECTING A WALLET TO CONNECT TO VAULT, THEN BEGIN MINTING.
          </p>
        </div>
        <div class="bespoke_box_list" v-if="bespoke_now_number == 2">
          <div class="adress_log adress_log1">
            <p class="adress">{{ walletAddress }}</p>
            <div class="logout_xian"></div>
            <div class="logout_btn" @click="logout">Log Out</div>
          </div>
          <div class="bespoke_box_listall">
            <div class="close" @click="closeend">
              <img
                src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
                alt=""
              />
            </div>
            <p class="title">CHOOSE YOUR BEANS</p>
            <div class="bespoke_list">
              <div class="bespoke_list_li">
                <div class="highlight" @click="highlight_xia">
                  <img
                    class="highlight1"
                    src="https://img.ohdat.io/foundo-website/assets/despoke/highlight.png"
                    alt=""
                  />
                  <img
                    class="change"
                    src="https://img.ohdat.io/foundo-website/assets/despoke/dou.png"
                    alt=""
                  />
                  <p class="not_ava">NOT<br />AVAILABLE</p>
                </div>
                <p class="name">BEANS#123</p>
                <p class="name">Available:2</p>
              </div>
              <div class="bespoke_list_li">
                <p class="highlight">
                  <img
                    class="highlight1"
                    src="https://img.ohdat.io/foundo-website/assets/despoke/highlight.png"
                    alt=""
                  />
                  <img
                    class="change"
                    src="https://img.ohdat.io/foundo-website/assets/despoke/dou.png"
                    alt=""
                  />
                </p>
                <p class="name">BEANS#123</p>
                <p class="name">Available:2</p>
              </div>
              <div class="bespoke_list_li">
                <p class="highlight">
                  <img
                    class="highlight1"
                    src="https://img.ohdat.io/foundo-website/assets/despoke/highlight.png"
                    alt=""
                  />
                  <img
                    class="change"
                    src="https://img.ohdat.io/foundo-website/assets/despoke/dou.png"
                    alt=""
                  />
                </p>
                <p class="name">BEANS#123</p>
                <p class="name">Available:2</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bespoke_box" v-if="bespoke_now_number == 3">
          <div class="adress_log">
            <p class="adress">{{ walletAddress }}</p>
            <div class="logout_xian"></div>
            <div class="logout_btn" @click="logout">Log Out</div>
          </div>
          <div class="bespoke_body">
            <div class="bespoke_left">
              <p class="text_size text_margin1">
                Azuki Beanz x FOUNDO Bespoke 18k Gold Necklace <br />with
                Diamonds and Enamel
              </p>
              <p class="text_size text_margin">
                Necklace in 18k gold with diamonds, 18k gold beanz<br />
                pendant with hand-crafted enamel
              </p>
              <div class="avatar text_margin">
                <p>
                  <img
                    src="https://img.ohdat.io/foundo-website/assets/despoke/dou.png"
                    alt=""
                  />
                </p>
                <div class="avatarbox">
                  <p class="name">BEANS#123</p>
                  <p class="change">CHANGE</p>
                </div>
              </div>
            </div>
            <div>
              <img
                class="bespoke_center"
                src="https://img.ohdat.io/foundo-website/assets/despoke/0.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="bespoke_right">
              <p class="text_size text_margin2">
                Mint with your Beanz and FOUNDO Pass
              </p>
              <div class="bespoke_box_right text_size text_margin">
                <p>Color:</p>
                <p>Yellow Gold/Pink</p>
              </div>
              <div class="bespoke_box_right text_size text_margin">
                <p>Price:</p>
                <p class="price">
                  <img
                    src="https://img.ohdat.io/foundo-website/assets/index/eth.png"
                    alt=""
                    srcset=""
                  />
                  <span>2</span>
                </p>
              </div>
              <div class="bespoke_box_right text_size text_margin">
                <p>Stock:</p>
                <p>0</p>
              </div>
              <div class="bespoke_box_right text_size text_margin">
                <p>Quantity:</p>
                <div class="bespoke_box_total">
                  <div
                    v-if="limitbe > 1"
                    class="sel"
                    @click="seldownShowbe"
                    :style="!seltionbe ? '' : 'border-bottom:none'"
                  >
                    <span>{{ selectNumbe }}</span>
                    <img
                      src="https://img.ohdat.io/foundo-website/assets/index/down.png"
                      v-if="!seltionbe"
                    />
                    <img
                      src="https://img.ohdat.io/foundo-website/assets/index/up.png"
                      v-else
                    />
                  </div>
                  <div v-else class="selno">
                    <span>{{ limitbe }}</span>
                  </div>
                  <div class="selDown" v-show="seltionbe">
                    <div @click="selNumbe(itemSelbe)">{{ itemSelbe }}</div>
                  </div>
                </div>
              </div>
              <div class="bespoke_box_right text_size text_margin">
                <p>Total:</p>
                <p class="price">
                  <img
                    src="https://img.ohdat.io/foundo-website/assets/index/eth.png"
                    alt=""
                    srcset=""
                  />
                  <span>0.3</span>
                </p>
              </div>
              <div class="be_confirm">CONFIRM</div>
              <div class="tishi">Free shipping on orders</div>
            </div>
          </div>
        </div>
      </div>
      <!-- error -->
      <div class="error" v-if="error_now">
        <div class="error_box">
          <div class="close" @click="close_error">
            <img
              src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
              alt=""
            />
          </div>
          <p class="error_title">Error</p>
          <p class="error_text" v-if="error_text != 'MetaMask'">
            {{ error_text }}
          </p>
          <p class="error_text" v-else>
            You have not installed
            <span @click="MetaMask">MetaMask</span>
            on your device.
          </p>
        </div>
      </div>
      <!-- swiper弹框 -->
      <div class="swiper_bullet_box" v-show="swiper_bullet_box">
        <div class="swiperbullet_box">
          <div class="close" @click="swiper_bullet">
            <img
              src="https://img.ohdat.io/foundo-website/assets/index/cha.png"
              alt=""
            />
          </div>
          <div class="swiper-container" id="artists_delm">
            <div class="swiper-wrapper" ref="swiperfea">
              <div
                class="swiper-slide"
                v-for="(itemed, keyed) in rightNowm"
                :key="keyed"
              >
                <div class="artists_box">
                  <p>
                    <img :src="itemed.img" alt="" />
                  </p>
                  <!-- <div class="artists_box_text">{{ itemed.text }}</div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev">
            <img
              src="https://img.ohdat.io/foundo-website/assets/avatar_right/left.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="swiper-button-next">
            <img
              src="https://img.ohdat.io/foundo-website/assets/avatar_right/right.png"
              alt=""
              srcset=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_goods_datail, get_purchase_options } from "@/api/goods/index.js";
import {
  place_goods_order_submit,
  place_goods_order,
} from "@/api/trade/index.js";
import Web3 from "web3";
import { NFT721M, NFT721M__factory } from "@ohdat/foundo-nft";
import { ethers, Wallet } from "ethers";
import { Message } from "element-ui";
import {
  logout,
  initialWeb3,
  getCurrentWallet,
  checkNetwork,
} from "@/utils/web3.js";
import "swiper/css/swiper.css";
import Swiper from "swiper";
let vm = null;
export default {
  name: "ceshi",
  data() {
    return {
      anim: false,
      anim0: false,
      anim1: false,
      anim2: false,
      anim4: false,
      anim5: false,
      anim6: false,
      anim7: false,
      ann: false,
      nowIndex: 0,
      back: "",
      img: "https://img.ohdat.io/foundo-website/assets/mp4/logo-loop.mp4",
      imged: "https://img.ohdat.io/foundo-website/assets/mp4/logo-begin.mp4",
      options: {
        licenseKey: "Q0MLK-05EIK-3K6H9-NP836-VPTJO",
        //是否显示导航，默认为false
        navigation: false,
        //为每个section设置背景色
        // sectionsColor: [
        //   "#41b883",
        //   "#ff5f45",
        //   "#0798ec",
        //   "#fec401",
        //   "#1bcee6",
        //   "#ee1a59",
        //   "#2c3e4f",
        //   "#ba5be9",
        //   "#b4b8ab",
        // ],
        autoScrolling: true,
        scrollOverflow: true,
        scrollOverflowOptions: {
          scrollY: false,
        },
        onLeave(origin, destination, direction, trigger) {
          vm.$refs.fullpage.api.setAllowScrolling(false);
          vm.$refs.fullpage.api.setKeyboardScrolling(false);
          vm.nowIndex = destination.index;
          console.log("now", vm.nowIndex);
          if (destination.index == 0) {
            vm.logoindex = 1;
            vm.img =
              "https://img.ohdat.io/foundo-website/assets/mp4/logo-loop.mp4";
            vm.back = "";
            vm.alllogo = true;
            vm.imgcode = 0;
          } else if (destination.index == 1) {
            vm.img = "";
            vm.back = "";
            vm.alllogo = true;
            const videoImg = document.getElementById("videoimged");
            videoImg.play();
          } else if (destination.index == 2) {
            vm.img = "";
            vm.back = "";
            vm.alllogo = true;
            vm.logoindex = 2;
          } else if (destination.index == 3) {
            vm.logoindex = 2;
            vm.img = "";
            vm.back = "";
            vm.alllogo = true;
            vm.imgcode = 0;
          } else if (destination.index == 4) {
            vm.jiashow = false;
            vm.img = "";
            vm.back = "BACK";
            vm.alllogo = false;
            vm.logoindex = 2;
            vm.imgcode = 0;
          } else if (destination.index == 5) {
            vm.img = "";
            vm.back = "BACK";
            vm.alllogo = false;
            vm.logoindex = 2;
            vm.imgcode = 0;
          } else if (destination.index == 6) {
            vm.img =
              "https://img.ohdat.io/foundo-website/assets/mp4/logo-loop.mp4";
            vm.back = "BACK";
            vm.alllogo = false;
            vm.logoindex = 2;
            vm.imgcode = 0;
            // vm.img = "https://img.ohdat.io/foundo/card.mp4";
          } else if (destination.index == 7) {
            vm.back = "BACK";
            vm.img = "";
            vm.alllogo = false;
            vm.logoindex = 2;
            vm.imgcode = 1;
            const videoImg = document.getElementById("videoimg1");
            videoImg.play();
          } else if (destination.index == 8) {
            vm.img = "";
            vm.back = "BACK";
            vm.alllogo = false;
            vm.logoindex = 2;
            vm.imgcode = 1;
            const videoImg1 = document.getElementById("videoimg2");
            videoImg1.play();
          } else {
            vm.img = "";
            vm.back = "";
            vm.alllogo = false;
            vm.logoindex = 2;
            vm.imgcode = 0;
          }

          if (destination.index == 0) {
            vm.anim = true;
          } else {
            vm.anim = false;
          }

          if (destination.index == 1) {
            vm.logoindex = 1;
            vm.anim0 = true;
          } else {
            vm.anim0 = false;
          }

          if (destination.index == 2) {
            vm.anim1 = true;
          } else {
            vm.anim1 = false;
          }

          if (destination.index == 3) {
            vm.anim2 = true;
          } else {
            vm.anim2 = false;
          }

          if (destination.index == 5) {
            vm.anim5 = true;
          } else {
            vm.anim5 = false;
          }

          if (destination.index == 6) {
            vm.anim6 = true;
          } else {
            vm.anim6 = false;
          }

          if (destination.index == 7) {
            vm.anim7 = true;
          } else {
            vm.anim7 = false;
          }
        },
      },
      showNumber: 3,
      invitation: "",
      wrong: "",
      hide: false,
      lefttext: "",
      righttext: "",
      videoEL1: null,
      videoEL2: null,
      videoEL3: null,
      play1: false,
      play2: false,
      play3: false,
      videoELm1: null,
      videoELm2: null,
      videoELm3: null,
      playm1: false,
      playm2: false,
      playm3: false,
      begin_audio1: null,
      jiashow: false,
      mint_now: false,
      bespoke_now: false,
      mint_now_number: 1,
      bespoke_now_number: 1,
      aaaa: 100,
      currentAccounttext: "",
      walletAddress: "",
      loginWallet: false,
      alllogo: false,
      percentage: 0,
      ethPrice: "",
      contract: "",
      limit: "",
      available: 0,
      selectNum: "",
      totalPrice: "",
      stock: "",
      status: "",
      contractAddress: "",
      original_stock: "",
      limitall: "",
      ennde: false,
      logoindex: 1,
      mint_btn: true,
      error_now: false,
      error_text: "",
      startX: 0,
      startY: 0,
      imgcode: 0,
      heightw: 0,
      seltion: false,
      itemSel: 1,
      activesli: "",
      type: 1,
      limitbe: 2,
      seltionbe: false,
      itemSelbe: 1,
      selectNumbe: 1,
      tempSwiper: "",
      tempSwiperm: "",
      tempSwiperbox: "",
      rightNow: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/bear_the_burden_of_society.gif?tr=w-478",
          text: "bear_the_burden_of_society",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/malwarepunk.gif?tr=w-478",
          text: "malwarepunk",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/ponzi_scheme.gif?tr=w-478",
          text: "ponzi_scheme",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/sweep_the_floor.gif?tr=w-478",
          text: "sweep_the_floor",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/undefined_blockchain.gif?tr=w-478",
          text: "undefined_blockchain",
        },
      ],
      rightNowm: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/bear_the_burden_of_society.gif?tr=w-478",
          text: "bear_the_burden_of_society",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/malwarepunk.gif?tr=w-478",
          text: "malwarepunk",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/ponzi_scheme.gif?tr=w-478",
          text: "ponzi_scheme",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/sweep_the_floor.gif?tr=w-478",
          text: "sweep_the_floor",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/undefined_blockchain.gif?tr=w-478",
          text: "undefined_blockchain",
        },
      ],
      Glitch_Bongdoe: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/bear_the_burden_of_society.gif?tr=w-478",
          text: "bear_the_burden_of_society",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/malwarepunk.gif?tr=w-478",
          text: "malwarepunk",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/ponzi_scheme.gif?tr=w-478",
          text: "ponzi_scheme",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/sweep_the_floor.gif?tr=w-478",
          text: "sweep_the_floor",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/undefined_blockchain.gif?tr=w-478",
          text: "undefined_blockchain",
        },
      ],
      Glitch_C4RDINAL: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/DANKSTORMY_hires.gif?tr=w-478",
          text: "DANKSTORMY_hires",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/HIGH_RISE.gif?tr=w-478",
          text: "HIGH_RISE",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/ROAD_LESS_TRAVELED.gif?tr=w-478",
          text: "ROAD_LESS_TRAVELED",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/SOLO_EXHIBIT.gif?tr=w-478",
          text: "SOLO_EXHIBIT",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/STRAWBERRY_SOUR.gif?tr=w-478",
          text: "STRAWBERRY_SOUR",
        },
      ],
      Glitch_KingXerox: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/CYRPTOLAND.gif?tr=w-478",
          text: "CYRPTOLAND",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/Degen_Evolution.gif?tr=w-478",
          text: "Degen_Evolution",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/INFLUENCERS.gif?tr=w-478",
          text: "INFLUENCERS",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/PERFECT_REKT.gif?tr=w-478",
          text: "PERFECT REKT",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/STAKE_BURN.gif?tr=w-478",
          text: "STAKE & BURN",
        },
      ],
      AI_CharlesAI: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/last_green_candle.png?tr=w-478",
          text: "last_green_candle",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/liquidation_cascade.png?tr=w-478",
          text: "liquidation_cascade",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/memepolis_gif.gif?tr=w-478",
          text: "memepolis_gif",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/Post_Sam_Desolation.png?tr=w-478",
          text: "PPost_Sam_Desolation",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/The_Architect.png?tr=w-478",
          text: "The_Architect",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/valley_in_the_room2.png?tr=w-478",
          text: "valley_in_the_room2",
        },
      ],
      AI_GeneKogan: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/GeneKogan/math_class_gif.gif?tr=w-478",
          text: "math_class_gif",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/GeneKogan/mps_gif.gif?tr=w-478",
          text: "mps_gif",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/GeneKogan/scrollwave_gif.gif?tr=w-478",
          text: "scrollwave_gif",
        },
      ],
      AI_Str4ngeThing: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/0URF4TH3R_the_king.png?tr=w-478",
          text: "0URF4TH3R_the_king",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/JUDG3M3NT.jpg?tr=w-478",
          text: "JUDG3M3NT",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/LUC1F3R.png?tr=w-478",
          text: "LUC1F3R",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/SUPERM3_C0LL3CTOR.jpg?tr=w-478",
          text: "SUPERM3_C0LL3CTOR",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/THE_PR1NC3_R3GENT_THE_GENERAL.png?tr=w-478",
          text: "THE_PR1NC3_R3GENT_THE_GENERAL",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/THE_THRU3_K1NG.jpg?tr=w-478",
          text: "THE_THRU3_K1NG",
        },
      ],
      PopPrecisionismMinimalism_0xflat: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/a_day_with_papa.jpg?tr=w-478",
          text: "a_day_with_papa",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/beer_factory.jpg?tr=w-478",
          text: "beer_factory",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/city_light.jpg?tr=w-478",
          text: "city_light",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/harvest.jpg?tr=w-478",
          text: "harvest",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/lone_house.jpg?tr=w-478",
          text: "lone_house",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/three_little_birds.jpg?tr=w-478",
          text: "three_little_birds",
        },
      ],
      PopPrecisionismMinimalism_Terrell: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/bub_s.jpg?tr=w-478",
          text: "bub's",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/car_shopping.jpg?tr=w-478",
          text: "car_shopping",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/CASH_4_HALOS.jpg?tr=w-478",
          text: "CASH_4_HALOS",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/fancy_thieves_gif.gif?tr=w-478",
          text: "fancy_thieves_gif",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/mission_mojave.jpg?tr=w-478",
          text: "mission_mojave",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/pariahs.jpg?tr=w-478",
          text: "pariahs",
        },
      ],
      On_chain_Diid: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/deus_ex_machina.png?tr=w-478",
          text: "deus ex machina",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/do_anything_now.png?tr=w-478",
          text: "do anything now",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/reference.png?tr=w-478",
          text: "reference",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/solemn_grail.png?tr=w-478",
          text: "solemn grail",
        },
      ],
      On_chain_Smokestacks: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/blood_brothers_gif.gif?tr=w-478",
          text: "blood brothers_gif",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/business_as_usual_gif.gif?tr=w-478",
          text: "business as usual_gif",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_alpha.gif?tr=w-478",
          text: "rarestacks_alpha",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_kek.png?tr=w-478",
          text: "rarestacks_kek",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_thank_you.gif?tr=w-478",
          text: "rarestacks_thank_you",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_wired.gif?tr=w-478",
          text: "rarestacks_wired",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks.gif?tr=w-478",
          text: "rarestacks",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/shot_sage_red_monster_gif.gif?tr=w-478",
          text: "shot sage red monster_gif",
        },
      ],
      Photography_KeithHaringPhotoSet: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/debbie_dick.jpg?tr=w-478",
          text: "debbie_dick",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/fight_aids_worldwide.jpg",
          text: "fight_aids_worldwide",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/ignorance_fear_silence_death.jpeg?tr=w-478",
          text: "ignorance_fear_silence_death",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/keith_and_julia.jpg?tr=w-478",
          text: "keith_and_julia",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/radiant_baby.jpg?tr=w-478",
          text: "radiant_baby",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/safe_sex.jpeg?tr=w-478",
          text: "safe_sex",
        },
      ],
      Photography_LouisDazy: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/blindsided.jpg?tr=w-478",
          text: "blindsided",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/lost_in_the_city_lights.jpg?tr=w-478",
          text: "lost_in_the_city_lights",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/motel_dreams.jpg?tr=w-478",
          text: "motel_dreams",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/pain_gif.gif?tr=w-478",
          text: "pain(T)_gif",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/PalmDreams.jpg?tr=w-478",
          text: "PalmDreams",
        },
      ],
      Surrealism_1dontknows: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/carpe_diem.jpg?tr=w-478",
          text: "carpe_diem",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/daydreaming.jpg?tr=w-478",
          text: "daydreaming",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/Glimpse_of_us.jpg?tr=w-478",
          text: "Glimpse_of_us",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/guardian_of_death.jpg?tr=w-478",
          text: "guardian_of_death",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/the_beauty_of_a_pure_soul.jpg?tr=w-478",
          text: "the_beauty_of_a_pure_soul",
        },
      ],
      Surrealism_RedruM: [
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/Discordia.png?tr=w-478",
          text: "Discordia",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/grifters.png?tr=w-478",
          text: "grifters",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/RED_MIDAS.png?tr=w-478",
          text: "RED_MIDAS",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/rosso.png?tr=w-478",
          text: "rosso",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/she.png?tr=w-478",
          text: "she",
        },
        {
          img: "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/when_red_called_me.png?tr=w-478",
          text: "when_red_called_me",
        },
      ],
      mySwiper_index: 1,
      mySwiper_indexm: 100,
      swiper_bullet_box: false,
      preloadCount: 0,
      percent: 0,
      playMusict: false,
    };
  },
  created() {
    vm = this;
    if (!this.$route.query.page || this.$route.query.page != "mint") {
      this.showNumber = 2;
    }
  },
  watch: {
    showNumber: function (newValue) {
      if (newValue == 2) {
        this.logoindex = 1;
        // this.begin_audio1.play();
        // this.loop_audio.pause();
      } else if (newValue == 3) {
        this.alllogo = true;
        this.logoindex = 1;
        // this.begin_audio1.pause();
        // this.loop_audio.play();
      } else {
        this.logoindex = 1;
      }
    },
    mint_now_number: function (newValue) {
      if (newValue == 4) {
        this.loop_audio.pause();
        // this.loop_audio.play();
      } else {
        this.loop_audio.play();
        // this.loop_audio.pause();
      }
    },
  },
  mounted() {
    // this.customers();
    if (window.screen.width < 1024) {
      this.artistsDelm();
      this.artistsBoxm();
    } else {
      this.artistsDel();
    }
    this.$refs.fullpage.api.setAllowScrolling(false);
    this.$refs.fullpage.api.setKeyboardScrolling(false);
    this.heightw = document.documentElement.clientHeight;
    this.preload();
    this.videoEL1 = this.$refs.video1;
    this.videoEL2 = this.$refs.video2;
    this.videoEL3 = this.$refs.video3;
    this.videoELm1 = this.$refs.videom1;
    this.videoELm2 = this.$refs.videom2;
    this.videoELm3 = this.$refs.videom3;
    this.begin_audio1 = this.$refs.begin_audio1;
    this.loop_audio = this.$refs.loop_audio;
    this.handleScroll();
    if (this.$route.query.page && this.$route.query.page == "mint") {
      this.$refs.fullpage.api.silentMoveTo(2, 0);
    }
    this.implement();
    this.getGoodsDetail();
    let that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "wallet_address") {
        if (!e.newValue) {
          if (e.oldValue) {
            logout();
          }
          if (that.type == 1) {
            that.mint_now_number = 1;
          } else {
            that.bespoke_now_number = 1;
          }
        } else {
          that.currentAccounttext = e.newValue;
          that.walletAddress =
            e.newValue.substr(0, 4) + "***" + e.newValue.substr(-4);
          if (that.type == 1) {
            that.mint_now_number = 2;
          } else {
            that.bespoke_now_number = 2;
          }
          that.getGoodsDetail();
          that.getPurchaseOptions();
        }
      }
    });
  },
  methods: {
    implement() {
      var that = this;
      that.showNumber = 2;
      var videoDOM = document.getElementById("myVideo");
      var videoDOM1 = document.getElementById("myVideo1");
      var videoImg = document.getElementById("videoimg1");
      videoImg.play();
      var videoImg1 = document.getElementById("videoimg2");
      videoImg1.play();
      that.hide = true;
      videoDOM.play();
      videoDOM1.play();
      videoDOM.addEventListener("ended", function () {
        that.hide = false;
        that.showNumber = 3;
      });
    },
    playMusic() {
      this.playMusict = !this.playMusict;
      if (this.playMusict) {
        this.loop_audio.play();
      } else {
        this.loop_audio.pause();
      }
    },
    swiper_bullet() {
      this.swiper_bullet_box = false;
    },
    rightShow(i) {
      // console.log(i);
      this.mySwiper_index = i;
      this.rightNow = [];
      // console.log(this.rightNow);
      this.tempSwiper.removeAllSlides();
      if (i == 1) {
        this.rightNow = this.Glitch_Bongdoe;
      } else if (i == 2) {
        this.rightNow = this.Glitch_C4RDINAL;
      } else if (i == 3) {
        this.rightNow = this.Glitch_KingXerox;
      } else if (i == 4) {
        this.rightNow = this.AI_CharlesAI;
      } else if (i == 5) {
        this.rightNow = this.AI_GeneKogan;
      } else if (i == 6) {
        this.rightNow = this.AI_Str4ngeThing;
      } else if (i == 7) {
        this.rightNow = this.PopPrecisionismMinimalism_0xflat;
      } else if (i == 8) {
        this.rightNow = this.PopPrecisionismMinimalism_Terrell;
      } else if (i == 9) {
        this.rightNow = this.On_chain_Diid;
      } else if (i == 10) {
        this.rightNow = this.On_chain_Smokestacks;
      } else if (i == 11) {
        this.rightNow = this.Photography_KeithHaringPhotoSet;
      } else if (i == 12) {
        this.rightNow = this.Photography_LouisDazy;
      } else if (i == 13) {
        this.rightNow = this.Surrealism_1dontknows;
      } else if (i == 14) {
        this.rightNow = this.Surrealism_RedruM;
      }

      for (let index = 0; index < this.rightNow.length; index++) {
        // console.log(999);
        this.tempSwiper.appendSlide(
          `<div style="height: 47.222222rem !important;
                    margin: auto;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;" class="swiper-slide">
              <div class="artists_box" style:="width: 100%;
                        max-height: 44.444444rem;
                        text-align: center;margin: auto;">
                <p style="width: 26.555556rem;margin: auto;">
                    <img style="width: 100%;
                        max-height: 37.777778rem;
                        margin: auto;
                        text-align: center;" src="${this.rightNow[index].img}" alt="" />
                  </p>
                  // <div style="font-size: 1.888889rem;
                  //       color: #FFFFFF;
                  //       text-align: center;
                  //       margin-top: 1.666667rem;" class="artists_box_text">${this.rightNow[index].text}</div>
                </div>
            </div>`
        );
      }
      setTimeout(() => {
        this.tempSwiper.update();
      }, 2000);
    },
    rightShowm(i) {
      this.swiper_bullet_box = true;
      this.mySwiper_indexm = i;
      this.rightNowm = [];
      console.log(this.tempSwiperm);
      this.tempSwiperm.removeAllSlides();
      console.log(this.tempSwiperm);
      if (i == 100) {
        this.rightNowm = this.Glitch_Bongdoe;
      } else if (i == 101) {
        this.rightNowm = this.Glitch_C4RDINAL;
      } else if (i == 102) {
        this.rightNowm = this.Glitch_KingXerox;
      } else if (i == 103) {
        this.rightNowm = this.AI_CharlesAI;
      } else if (i == 104) {
        this.rightNowm = this.AI_GeneKogan;
      } else if (i == 105) {
        this.rightNowm = this.AI_Str4ngeThing;
      } else if (i == 106) {
        this.rightNowm = this.PopPrecisionismMinimalism_0xflat;
      } else if (i == 107) {
        this.rightNowm = this.PopPrecisionismMinimalism_Terrell;
      } else if (i == 108) {
        this.rightNowm = this.On_chain_Diid;
      } else if (i == 109) {
        this.rightNowm = this.On_chain_Smokestacks;
      } else if (i == 110) {
        this.rightNowm = this.Photography_KeithHaringPhotoSet;
      } else if (i == 111) {
        this.rightNowm = this.Photography_LouisDazy;
      } else if (i == 112) {
        this.rightNowm = this.Surrealism_1dontknows;
      } else if (i == 113) {
        this.rightNowm = this.Surrealism_RedruM;
      }
      for (let index = 0; index < this.rightNowm.length; index++) {
        // console.log(999);
        this.tempSwiperm.appendSlide(
          `<div style="height: 94.166667rem !important;
                    margin: auto;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;" class="swiper-slide">
              <div class="artists_box" style:="width: 100%;
                        max-height: 94.166667rem;
                        text-align: center;">
                <p>
                    <img style="width: 53.777778rem;
                        max-height: 87rem;
                        margin: auto;
                        text-align: center;" src="${this.rightNowm[index].img}" alt="" />
                  </p>
                </div>
            </div>`
        );
      }
      // <div
      //   style="font-size: 3rem;
      //                   color: #FFFFFF;
      //                   text-align: center;
      //                   margin-top: 1.666667rem;"
      //   class="artists_box_text"
      // >
      //   ${this.rightNowm[index].text}
      // </div>;
      setTimeout(() => {
        this.tempSwiperm.update();
      }, 2000);
    },
    // Bespoke轮播
    customers() {
      var mySwiper = new Swiper("#swiperCus", {
        direction: "horizontal",
        mousewheel: false,
        centeredSlides: true,
        slidesPerView: 3,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        loop: true,
        spaceBetween: 158,
        autoplay: false,
        // autoplay:false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function () {
            // console.log((this.activeIndex - 1 + 3) % 3);
            vm.activesli = (this.activeIndex - 1 + 3) % 3;
          },
        },
      });
    },
    artistsDel() {
      this.tempSwiper = new Swiper("#artists_del", {
        direction: "horizontal",
        initialSlide: 0,
        mousewheel: false,
        centeredSlides: true,
        slidesPerView: 1,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        loop: true,
        speed: 300,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        // clickable: true,
        // autoplay:false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function () {
            // console.log((this.activeIndex - 1 + 3) % 3);
            vm.activesli = (this.activeIndex - 1 + 3) % 3;
          },
        },
      });
      // this.rightNow = this.Glitch_Bongdoe;
    },
    artistsDelm() {
      this.tempSwiperm = new Swiper("#artists_delm", {
        direction: "horizontal",
        initialSlide: 0,
        mousewheel: false,
        centeredSlides: true,
        slidesPerView: 1,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        loop: true,
        speed: 300,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        // clickable: true,
        // autoplay:false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function () {
            // console.log((this.activeIndex - 1 + 3) % 3);
            vm.activesli = (this.activeIndex - 1 + 3) % 3;
          },
        },
      });
      // this.rightNow = this.Glitch_Bongdoe;
    },
    artistsBoxm() {
      this.tempSwiperbox = new Swiper("#artistsBoxm", {
        direction: "horizontal",
        initialSlide: 0,
        mousewheel: false,
        centeredSlides: true,
        slidesPerView: 1,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        loop: true,
        speed: 300,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        // clickable: true,
        // autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function () {
            // console.log((this.activeIndex - 1 + 3) % 3);
            vm.activesli = (this.activeIndex - 1 + 3) % 3;
          },
        },
      });
      // this.rightNow = this.Glitch_Bongdoe;
    },
    highlight_xia() {
      // alert(9999);
      this.bespoke_now_number = 3;
    },
    //下拉选择数量
    seldownShow() {
      this.seltion = !this.seltion;
      if (this.selectNum == 2) {
        this.itemSel = 1;
      } else {
        this.itemSel = 2;
      }
    },
    selNum(i) {
      this.selectNum = i;
      this.totalPrice = (this.ethPrice * this.selectNum).toFixed(2);
      this.seltion = !this.seltion;
    },
    //下拉选择数量
    seldownShowbe() {
      this.seltionbe = !this.seltionbe;
      if (this.selectNumbe == 2) {
        this.itemSelbe = 1;
      } else {
        this.itemSelbe = 2;
      }
    },
    selNumbe(i) {
      this.selectNumbe = i;
      // this.totalPrice = (this.ethPrice * this.selectNum).toFixed(2);
      this.seltionbe = !this.seltionbe;
    },
    touchstart(e) {
      this.startX = e.touches[0].pageX;
      this.startY = e.touches[0].pageY;
    },
    touchmove(e) {
      var that = this;
      /* 判断移动方向 */
      let X = e.touches[0].pageX - that.startX,
        Y = e.touches[0].pageY - that.startY;
      if (X > 0 && Math.abs(X) > Math.abs(Y)) {
        //向右
      } else if (X < 0 && Math.abs(X) > Math.abs(Y)) {
        //向左
      } else if (Y > 0 && Math.abs(Y) > Math.abs(X)) {
        //向下
        if (
          (that.nowIndex - 1 < 3 || that.nowIndex - 1 >= 7) &&
          !that.mint_now &&
          that.showNumber == 3
        ) {
          that.$refs.fullpage.api.setAllowScrolling(true);
          that.$refs.fullpage.api.setKeyboardScrolling(true);
        }
      } else if (Y < 0 && Math.abs(Y) > Math.abs(X)) {
        //向上
        if (
          (that.nowIndex + 1 <= 3 || that.nowIndex + 1 > 7) &&
          !that.mint_now &&
          that.showNumber == 3
        ) {
          that.$refs.fullpage.api.setAllowScrolling(true);
          that.$refs.fullpage.api.setKeyboardScrolling(true);
        }
      }
    },
    touchend(e) {
      this.$refs.fullpage.api.setAllowScrolling(false);
      this.$refs.fullpage.api.setKeyboardScrolling(false);
    },
    preload() {
      var loading;
      if (window.screen.width < 1024) {
        loading = document.getElementById("loading_m");
      } else {
        loading = document.getElementById("loading");
      }
      let imgs = [
        "https://img.ohdat.io/foundo-website/assets/index/logo.png",
        "https://img.ohdat.io/foundo-website/assets/index/logo1.png",
        "https://img.ohdat.io/foundo-website/assets/index/discord.png",
        "https://img.ohdat.io/foundo-website/assets/index/twitter.png",
        "https://img.ohdat.io/foundo-website/assets/index/instagram.png",
        "https://img.ohdat.io/foundo-website/assets/index/you.png",
        "https://img.ohdat.io/foundo-website/assets/index/you_m.png",
        "https://img.ohdat.io/foundo-website/assets/index/youxian.png",
        "https://img.ohdat.io/foundo-website/assets/index/card.png",
        "https://img.ohdat.io/foundo-website/assets/index/jia.png",
        "https://img.ohdat.io/foundo-website/assets/index/jian.png",
        "https://img.ohdat.io/foundo-website/assets/index/team-su.png",
        "https://img.ohdat.io/foundo-website/assets/index/team-alberto.png",
        "https://img.ohdat.io/foundo-website/assets/index/team-jamie.png",
        "https://img.ohdat.io/foundo-website/assets/index/right.png",
        "https://img.ohdat.io/foundo-website/assets/index/xia.png",
        "https://img.ohdat.io/foundo-website/assets/index/left.png",
        "https://img.ohdat.io/foundo-website/assets/index/cha.png",
        "https://img.ohdat.io/foundo-website/assets/index/card_small.png",
        "https://img.ohdat.io/foundo-website/assets/index/eth.png",
        "https://img.ohdat.io/foundo-website/assets/index/down.png",
        "https://img.ohdat.io/foundo-website/assets/index/up.png",
        // "https://img.ohdat.io/foundo-website/assets/index/jiantrue.png",
        // "https://img.ohdat.io/foundo-website/assets/index/jianfalse.png",
        // "https://img.ohdat.io/foundo-website/assets/index/jiatrue.png",
        // "https://img.ohdat.io/foundo-website/assets/index/jiafalse.png",
        "https://img.ohdat.io/foundo-website/assets/index/opensea.png",
        "https://img.ohdat.io/foundo-website/assets/index/mintbra.png",
        "https://img.ohdat.io/foundo-website/assets/index/mintbra_m.png",
        "https://img.ohdat.io/foundo-website/assets/index/foundo_tbox.png",
        "https://img.ohdat.io/foundo-website/assets/index/card_small_m.png",
        // Glitch_Bongdoe
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/bear_the_burden_of_society.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/malwarepunk.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/ponzi_scheme.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/sweep_the_floor.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/Bongdoe/undefined_blockchain.gif?tr=w-478",
        // Glitch_C4RDINAL
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/DANKSTORMY_hires.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/HIGH_RISE.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/ROAD_LESS_TRAVELED.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/SOLO_EXHIBIT.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/C4RDINAL/STRAWBERRY_SOUR.gif?tr=w-478",
        // Glitch_KingXerox
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/CYRPTOLAND.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/Degen_Evolution.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/INFLUENCERS.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/PERFECT_REKT.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Glitch/KingXerox/STAKE_BURN.gif?tr=w-478",
        // AI_CharlesAI
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/last_green_candle.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/liquidation_cascade.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/memepolis_gif.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/Post_Sam_Desolation.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/The_Architect.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/CharlesAI/valley_in_the_room2.png?tr=w-478",
        // AI_GeneKogan
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/GeneKogan/math_class_gif.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/GeneKogan/mps_gif.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/GeneKogan/scrollwave_gif.gif?tr=w-478",
        // AI_Str4ngeThing
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/0URF4TH3R_the_king.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/JUDG3M3NT.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/LUC1F3R.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/SUPERM3_C0LL3CTOR.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/THE_PR1NC3_R3GENT_THE_GENERAL.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/AI/Str4ngeThing/THE_THRU3_K1NG.jpg?tr=w-478",
        // PopPrecisionismMinimalism_0xflat
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/a_day_with_papa.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/beer_factory.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/city_light.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/harvest.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/lone_house.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/0xflat/three_little_birds.jpg?tr=w-478",
        // PopPrecisionismMinimalism_Terrell
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/bub_s.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/car_shopping.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/CASH_4_HALOS.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/fancy_thieves_gif.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/mission_mojave.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/PopPrecisionismMinimalism/Terrell/pariahs.jpg?tr=w-478",
        // On_chain_Diid
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/deus_ex_machina.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/do_anything_now.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/reference.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Diid/solemn_grail.png?tr=w-478",
        // On_chain_Smokestacks
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/blood_brothers_gif.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/business_as_usual_gif.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_alpha.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_kek.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_thank_you.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks_wired.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/rarestacks.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/On_chain/Smokestacks/shot_sage_red_monster_gif.gif?tr=w-478",
        // Photography_KeithHaringPhotoSet
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/debbie_dick.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/fight_aids_worldwide.jpg",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/ignorance_fear_silence_death.jpeg",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/keith_and_julia.jpg",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/radiant_baby.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/KeithHaringPhotoSet/safe_sex.jpeg?tr=w-478",
        // Photography_LouisDazy
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/blindsided.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/lost_in_the_city_lights.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/motel_dreams.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/pain_gif.gif?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Photography/LouisDazy/PalmDreams.jpg?tr=w-478",
        // Surrealism_1dontknows
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/carpe_diem.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/daydreaming.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/Glimpse_of_us.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/guardian_of_death.jpg?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/1dontknows/the_beauty_of_a_pure_soul.jpg?tr=w-478",
        // Surrealism_RedruM
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/Discordia.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/grifters.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/RED_MIDAS.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/rosso.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/she.png?tr=w-478",
        "https://img.ohdat.io/foundo-website/assets/avatar_right/Surrealism/RedruM/when_red_called_me.png?tr=w-478",
        // left_logo
        "https://img.ohdat.io/foundo-website/assets/avatar_left/Bongdoe.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/C4RDNIAL.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/KingXerox.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/0xflat.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/Terrell.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/CharlesAI.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/GeneKogan.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/Str4ngThing.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/Diid.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/Smokestacks.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/KeithharingPhotoSet.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/LoinsDazy.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/1dontknows.png",
        "https://img.ohdat.io/foundo-website/assets/avatar_left/RedruM.png",
        "https://img.ohdat.io/foundo-website/assets/index/play.png",
      ];
      for (let img of imgs) {
        let image = new Image();
        image.src = img;
        image.onload = () => {
          this.preloadCount++;
          // 计算图片加载的百分数，绑定到percent变量
          let percentNum = Math.floor((this.preloadCount / imgs.length) * 100);
          this.percent = `${percentNum}%`;
          if (percentNum == 100) {
            // console.log(888);
            // loading.classList.add("loadingtransform");
            // console.log(loading.classList);
          }
        };
      }
    },
    close_error() {
      this.mint_btn = true;
      this.error_now = false;
    },
    ended() {
      var time = setTimeout(() => {
        this.ennde = true;
        clearTimeout(time);
      }, 16000);
    },
    jiaTrue() {
      this.limit = 2;
      this.selectNum = 2;
      this.totalPrice = (this.ethPrice * this.selectNum).toFixed(2);
    },
    jianTrue() {
      this.limit = 1;
      this.selectNum = 1;
      this.totalPrice = (this.ethPrice * this.selectNum).toFixed(2);
    },
    handleScroll(e) {
      var direction;
      var that = this;
      document.body.addEventListener("DOMMouseScroll", function (event) {
        alert(that.nowIndex);
        direction =
          event.detail && (event.detail > 0 ? "mousedown" : "mouseup");

        if (direction == "mouseup") {
          //向下
          if (
            (that.nowIndex - 1 < 3 || that.nowIndex - 1 >= 7) &&
            !that.mint_now &&
            that.showNumber == 3
          ) {
            that.$refs.fullpage.api.setAllowScrolling(true);
            that.$refs.fullpage.api.setKeyboardScrolling(true);
          }
        } else if (direction == "mousedown") {
          //向上
          if (
            (that.nowIndex + 1 <= 3 || that.nowIndex + 1 > 7) &&
            !that.mint_now &&
            that.showNumber == 3
          ) {
            that.$refs.fullpage.api.setAllowScrolling(true);
            that.$refs.fullpage.api.setKeyboardScrolling(true);
          }
        }
      });

      // chrome and ie
      document.body.onmousewheel = function (event) {
        event = event || window.event;
        direction =
          event.wheelDelta && (event.wheelDelta > 0 ? "mouseup" : "mousedown");
        if (direction == "mouseup") {
          //向下
          if (
            (that.nowIndex - 1 < 3 || that.nowIndex - 1 >= 7) &&
            !that.mint_now &&
            that.showNumber == 3
          ) {
            that.$refs.fullpage.api.setAllowScrolling(true);
            that.$refs.fullpage.api.setKeyboardScrolling(true);
          }
        } else if (direction == "mousedown") {
          //向上
          if (
            (that.nowIndex + 1 <= 3 || that.nowIndex + 1 > 7) &&
            !that.mint_now &&
            that.showNumber == 3
          ) {
            that.$refs.fullpage.api.setAllowScrolling(true);
            that.$refs.fullpage.api.setKeyboardScrolling(true);
          }
        }
      };
    },
    //status获取
    async getGoodsDetail() {
      const params = {
        id: 12,
      };
      let res = await get_goods_datail(params);
      console.log(res);
      if (res.code == 200) {
        this.stock = res.data.stock;
        this.original_stock = res.data.original_stock;
        this.status = res.data.status;
        this.contractAddress = res.data.token_address;
        this.$store.commit("order/POST_GOODS_INFO", res.data);
        if (res.data.status == 0) {
          //未开始
          // this.expire3 = false;
          // this.expire2 = true;
          // this.expire1 = true;
          // this.active3 = true;
          // this.active2 = true;
          // this.active1 = true;
        } else if (res.data.status == -1) {
          // sould out
        } else if (res.data.status == 1) {
          //公售
        } else if (res.data.status == 4) {
          //白名单
        }
      } else {
        console.log("res err", res);
      }
    },
    //mint 状态
    async getPurchaseOptions() {
      if (this.status != 6 && this.status != 7) {
        const params = {
          id: 12,
        };
        let res = await get_purchase_options(params);
        console.log(res);
        if (res.code === 200) {
          this.ethPrice = Web3.utils.fromWei(res.data.price + "", "ether");
          this.contract = res.data.contract_method;
          this.limit = res.data.purchase_limit;
          this.available = res.data.available;
          this.limitall = res.data.purchase_limit;
          if (this.limit == 2) {
            this.selectNum = 2;
          } else {
            this.selectNum = this.limit;
          }
          this.totalPrice = (this.ethPrice * this.selectNum).toFixed(2);
          if (this.totalPrice == "0.00") {
            this.totalPrice = 0;
          }
        } else if (
          res.code === 1101 ||
          res.code === 1102 ||
          res.code === 1103 ||
          res.code === 1104 ||
          res.code === 1105
        ) {
          this.limit = 0;
          this.available = 0;
          this.limitall = 0;
          this.totalPrice = 0;
        }
      }
    },
    async placeGoodsOrderSubmit(nonce) {
      let formData = new FormData();
      formData.append("nonce", nonce);
      let res = await place_goods_order_submit(formData);
      console.log("placeGoodsOrderSubmit", res);
      if (res.code == 200) {
        console.log("place_goods_order_submit", "true");
        // this.$store.commit('mask/changeIndex', 1)
      } else {
        console.log("place_goods_order_submit", "err");
      }
    },
    async mint() {
      let that = this;
      that.mint_btn = false;
      let formData = new FormData();
      console.log("totalPrice====" + this.totalPrice);
      console.log("quantity====" + this.selectNum);
      formData.append("goods_id", "12");
      formData.append("quantity", this.selectNum);
      that.successNum = that.selectNum;
      let networkResult = await checkNetwork();
      console.log(networkResult);
      if (networkResult != "success") {
        Message({
          message: "Please switch to Ethereum Main Network",
          type: "error",
          duration: 3 * 1000,
        });
        that.mint_btn = true;
        return;
      }

      let res = await place_goods_order(formData);
      if (res.code == 200) {
        let provider = window.web3Provider;
        const signer = provider.getSigner();
        let orderInfo = res.data;
        let contract = await NFT721M__factory.connect(
          orderInfo.contract_address,
          signer
        );
        let transactionSubmit;
        //是否点击确认
        try {
          if (that.status == 1) {
            transactionSubmit = await contract.mint(orderInfo.quantity, {
              value: orderInfo.price.toString(),
            });
          } else if (that.status == 4) {
            transactionSubmit = await contract.whiteListMint(
              orderInfo.quantity,
              orderInfo.hash,
              orderInfo.signature,
              orderInfo.block_height,
              orderInfo.nonce,
              { value: orderInfo.price.toString() }
            );
          } else {
            return;
          }
          console.log("confirm transaction");
          that.placeGoodsOrderSubmit(orderInfo.nonce);
          that.mint_now_number = 3;
          that.progressBar();
          that.getGoodsDetail();
          that.getPurchaseOptions();
        } catch (error) {
          console.log("transaction submit failed", error);
          if (error.toString().includes("insufficient funds")) {
            //没钱
            that.error_text = "Insufficient funds";
            that.error_now = true;
          } else if (error.toString().includes("user rejected transaction")) {
            //用户拒绝
          } else if (error.toString().includes("transaction may fail")) {
            that.error_text = "Transaction may fail";
            that.error_now = true;
          } else if (error.toString().includes("mint not available")) {
            that.error_text = "Mint not started yet";
            that.error_now = true;
          } else {
            Message({
              message: error.toString(),
              type: "error",
              duration: 3 * 1000,
            });
            that.error_text = "Transaction submit failed";
            that.error_now = true;
          }

          this.mint_btn = true;
          return;
        }

        try {
          let transactionComplete = await transactionSubmit.wait();
          console.log(transactionComplete, "receipt");
          // that.processing = false;
          // that.successful = true;
          // that.btnListShow = true;
          that.percentage = 100;
          var time = setTimeout(() => {
            that.mint_now_number = 4;
            that.begin_audio1.pause();
            that.loop_audio.pause();
            that.ended();
            clearTimeout(time);
          }, 1000);
        } catch (e) {
          console.log("transaction complete failed", e);
          Message({
            message: error.toString(),
            type: "error",
            duration: 3 * 1000,
          });
          that.error_text = "Transaction failed";
          that.error_now = true;
        }
      } else {
        console.log("place_goods_order", "err");
      }
    },
    progressBar() {
      var time = setInterval(() => {
        if (this.percentage <= 95) {
          this.percentage = this.percentage + 0.1;
        } else {
          clearInterval(time);
        }
      }, 10);
    },
    logout() {
      logout();
      if (this.type == 1) {
        this.mint_now_number = 1;
      } else {
        this.bespoke_now_number = 1;
      }
    },
    async metaMaskConnect() {
      logout();
      await initialWeb3("injected");
      await getCurrentWallet();
    },
    async walletConnectConnect() {
      logout();
      await initialWeb3("walletconnect");
      await getCurrentWallet();
    },
    mintNow(e) {
      this.type = e;
      if (this.type == 1) {
        this.mint_now_number = 1;
        this.mint_now = true;
        this.mint_btn = true;
      } else {
        this.bespoke_now_number = 1;
        this.bespoke_now = true;
      }
      this.$refs.fullpage.api.setAllowScrolling(false);
      this.$refs.fullpage.api.setKeyboardScrolling(false);
      this.getGoodsDetail();
      this.getPurchaseOptions();
      this.alllogo = false;
    },
    close() {
      this.mint_now = false;
      this.bespoke_now = false;
      this.ennde = false;
      this.alllogo = true;
      if (this.mint_now_number > 2) {
        this.mint_now_number = 1;
        this.percentage = 0;
      }
    },
    closeend() {
      this.bespoke_now = false;
    },
    showJia() {
      this.jiashow = !this.jiashow;
    },
    tttt() {
      this.wrong = "";
    },
    pscdEnter() {
      var that = this;
      // code enter
      const transform = that.invitation.split(" ").join("").toLocaleLowerCase();
      if (
        transform === "newgeneration" ||
        transform === "thenewgeneration" ||
        transform === "newgenaration" ||
        transform === "new_generation"
      ) {
        that.showNumber = 2;
        var videoDOM = document.getElementById("myVideo");
        var videoDOM1 = document.getElementById("myVideo1");
        var videoImg = document.getElementById("videoimg1");
        videoImg.play();
        var videoImg1 = document.getElementById("videoimg2");
        videoImg1.play();
        that.hide = true;
        videoDOM.play();
        videoDOM1.play();
        videoDOM.addEventListener("ended", function () {
          that.hide = false;
          that.showNumber = 3;
        });
        that.wrong = "";
      } else {
        that.pscd = "";
        that.wrong = "WRONG PASSCODE";
      }
    },
    next() {
      // 向下滚动一页
      this.$refs.fullpage.api.moveSectionDown();
    },
    up() {
      // 向上滚动一页
      this.$refs.fullpage.api.moveSectionUp();
    },
    moveTo() {
      this.$refs.fullpage.api.silentMoveTo(2, 0);
    },
    moveFaq() {
      this.$refs.fullpage.api.silentMoveTo(6, 0);
    },
    moveTeam() {
      this.$refs.fullpage.api.silentMoveTo(6, 0);
    },
    moveManifesto() {
      this.$refs.fullpage.api.silentMoveTo(7, 0);
    },
    about() {
      this.$refs.fullpage.api.silentMoveTo(5, 0);
    },
    moveProduct() {
      this.$refs.fullpage.api.silentMoveTo(8, 0);
    },
    questionnaire() {
      this.$router.push("/application");
    },
    handleMouseEnter1() {
      this.play1 = true;
      this.videoEL1.play();
    },
    handleMouseEnter2() {
      this.play2 = true;
      this.videoEL2.play();
    },
    handleMouseEnter3() {
      this.play3 = true;
      this.videoEL3.play();
    },
    handleMouseEnterm1() {
      this.playm1 = true;
      this.videoELm1.play();
    },
    handleMouseEnterm2() {
      this.playm2 = true;
      this.videoELm2.play();
    },
    handleMouseEnterm3() {
      this.playm3 = true;
      this.videoELm3.play();
    },
    discord() {
      window.open("https://discord.gg/dTD4GMU88h");
    },
    twitter() {
      window.open("https://twitter.com/FoundoWorld");
    },
    instagram() {
      window.open("https://www.instagram.com/foundoworld");
    },
    opensea() {
      if (process.env.VUE_APP_MAIN_NETWORK == 5) {
        window.open("https://testnets.opensea.io/" + this.currentAccounttext);
      } else {
        window.open("https://opensea.io/" + this.currentAccounttext);
      }
    },
    MetaMask() {
      window.open("https://metamask.io/");
    },
    nahiyaLinkedin() {
      // window.open("");
    },
    nahiyaTwitter() {
      // window.open("");
    },
    nahiyaMedia() {
      window.open(
        "https://www.dazeddigital.com/fashion/article/55038/1/nahiya-su-on-launching-kvk-and-their-ultimate-aw21-accessories-trends"
      );
    },
    edisonLinkedin() {
      window.open("https://www.linkedin.com/in/edison-chen-00703b240");
    },
    edisonTwitter() {
      window.open(" https://twitter.com/Yellow_doggg");
    },
    jamieTwitter() {
      window.open("https://twitter.com/Jamiethetailor");
    },
  },
};
</script>
<style src="./index.scss" lang="scss" scoped></style>
<style src="./index.mobile.scss" lang="scss" scoped></style>